<template>
  <el-container style="background-color: #EDF5FC;height: 100%;">
    <el-aside style="width: 250px;background-color: #FFFFFF;position: relative;" v-if="!from || from == '0'">
      <el-menu ref="menus" :default-active="$route.path" class="el-menu-vertical-demo" @select="handleSelect" @close="handleClose" background-color="#FFFFFF" text-color="#303233" text-size="14px" :default-openeds="defaultOpeneds" active-text-color="#303233">
        <Menu :data="menuData" ref="customMenu"></Menu>
      </el-menu>
      <div class="stage-use-info">
        <el-progress :percentage="getUserStagePertage" :show-text="false"></el-progress>
        <span class="stage-use-desc">容量{{formatFileSize(userInfo.usedStorage)}}/{{formatFileSize(userInfo.maxStorage)}}</span>
      </div>
    </el-aside>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import Menu from '../components/MenuTree.vue'
import { formatFileSize } from "../../../common-components/src/utils/fileUtil";
export default {
  name: "resourceIndex",
  props: {
    from: {
      type: String,
      default: function () {
        return "0";
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
  },
  components: {
    Menu
  },
  beforeCreate() {
    window.resourceIndexVue = this
  },
  data() {
    return {
      menuData: [
        /*{
          id: 1,
          title: '最近',
          path: '/main/resource-index/history',
          name: 'history',
          img: require('@/assets/menu/history.png')
        },*/
        {
          id: 2,
          title: '全部文件',
          path: '/main/resource-index/resource-content',
          name: 'resource-content',
          img: require('@/assets/menu/resource-content.png'),
          children: [
            {
              id: 3,
              title: '文档',
              path: '/main/resource-index/resource-content/1',
              name: 'resource-content',
            },
            {
              id: 4,
              title: '图片',
              path: '/main/resource-index/resource-content/2',
              name: 'resource-content',
            },
            {
              id: 5,
              title: '音频',
              path: '/main/resource-index/resource-content/3',
              name: 'resource-content',
            },
            {
              id: 6,
              title: '视频',
              path: '/main/resource-index/resource-content/4',
              name: 'resource-content',
            },
            {
              id: 7,
              title: '其他',
              path: '/main/resource-index/resource-content/5',
              name: 'resource-content',
            }
          ]
        },
        /*{
          id: 8,
          title: '同步盘',
          path: '/main/resource-index/transfer',
          name: 'transfer',
          img: require('@/assets/menu/transfer.png')
        },*/
        /*{
          id: 9,
          title: '我的收藏',
          path: '/main/resource-index/my-collection',
          name: 'my-collection',
          img: require('@/assets/menu/collection.png'),
          children: [
            {
              id: 13,
              title: '1',
              path: '/main/resource-index/resource-content/6',
              name: '1',
            },
            {
              id: 14,
              title: '2',
              path: '/main/resource-index/resource-content/7',
              name: '2',
            },
          ]
        },*/
        /*{
          id: 10,
          title: '我的分享',
          path: '/main/resource-index/my-share',
          name: 'my-share',
          img: require('@/assets/menu/share.png')
        },
       {
          id: 11,
          title: '意见反馈',
          path: '/main/resource-index/feedback',
          name: 'feedback',
          img: require('@/assets/menu/feedback.png')
        },*/
        {
          id: 12,
          title: '回收站',
          path: '/main/resource-index/recycle',
          name: 'recycle',
          img: require('@/assets/menu/recycle.png')
        }
      ],
      defaultOpeneds: ['2']
    };
  },
  computed: {
    getUserStagePertage() {
      if (this.userInfo && this.userInfo.maxStorage) {
        return (this.userInfo.maxStorage && this.userInfo.usedStorage >= this.userInfo.maxStorage ? 100 : this.userInfo.usedStorage / this.userInfo.maxStorage * 100);
      }
      return 0;
    },
  },
  mounted() {
    console.log("resourceIndex mounted", this.$route.path)
    if (this.$route.path == '/main/resource-index') {
      this.$router.replace({path: '/main/resource-index/resource-content'});
    }
    for (let i in this.menuData){
      if (this.$route.path === this.menuData[i].path){
        if (this.$refs.customMenu !== undefined){
          this.$refs.customMenu.setDefaultSelected('submenu-' + this.menuData[i].id);
          break
        }
      }
    }
    // //设置进入页面是全部文件选中
    // if (this.$route.params.type == undefined || this.$route.params.type == 0) {
    //   if (this.$refs.customMenu !== undefined){
    //     this.$refs.customMenu.setDefaultSelected('submenu-2');
    //   }
    // }
  },
  watch: {
    $route() {
      // console.log('watch - resourceIndex', this.$route.path, 'type=', this.$route.params.type, new Date())
      if (this.$route.path.indexOf('/main/resource-index/resource-content') > -1) {
        if (typeof (this.$route.params.type) == "undefined") {
          if (this.$refs.customMenu !== undefined){
            this.$refs.customMenu.setDefaultSelected('submenu-2');
          }
        }
      }
    }
  },
  methods: {
    //选中菜单项时需要去除被设置为选中的父级菜单
    handleSelect() {
      this.$refs.customMenu.resetSelectSubMenu();
    },
    handleClose(key, keyPath) {
      // console.log('handleClose', key, keyPath, new Date())
      if (key === '2') {
        this.$refs.menus.open(keyPath);
        this.$refs.customMenu.onSelectSubMenu({ id: 2, path: '/main/resource-index/resource-content' })
      }
    },
    formatFileSize(fileSize) {
      if (typeof (fileSize) != "undefined" && fileSize != '-') {
        return formatFileSize(fileSize, 2);
      }
      return '-';
    },
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0;
  background-color: #ffffff;
  margin-left: 4px;
}
.el-menu {
  height: calc(100% - 60px);
  overflow-y: auto;
  border-right: none;
}
.stage-use-info {
  padding: 16px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 32px);

  .stage-use-desc {
    font-size: 12px;
    color: #909599;
  }
}
</style>
